module.exports = __webpack_public_path__ + "img/protected-bag-icon-2.95b88646.svg";